import { library } from '@fortawesome/fontawesome-svg-core'

import { faComments } from '@fortawesome/pro-solid-svg-icons/faComments'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faWindowMinimize } from '@fortawesome/pro-regular-svg-icons/faWindowMinimize'
import { faWindowMaximize } from '@fortawesome/pro-regular-svg-icons/faWindowMaximize'
import { faCompressAlt } from '@fortawesome/pro-solid-svg-icons/faCompressAlt'
import { faExpandAlt } from '@fortawesome/pro-solid-svg-icons/faExpandAlt'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons/faPaperclip'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { faMailBulk } from '@fortawesome/pro-solid-svg-icons/faMailBulk'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faFileUser } from '@fortawesome/pro-solid-svg-icons/faFileUser'
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter'
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare'
import { faMinusSquare } from '@fortawesome/pro-regular-svg-icons/faMinusSquare'
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare'
import { faSync } from '@fortawesome/pro-regular-svg-icons/faSync'
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faInbox } from '@fortawesome/pro-solid-svg-icons/faInbox'
import { faHourglassStart } from '@fortawesome/pro-solid-svg-icons/faHourglassStart'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation'
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faBoxAlt } from '@fortawesome/pro-solid-svg-icons/faBoxAlt'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faFolderDownload } from '@fortawesome/pro-solid-svg-icons/faFolderDownload'
import { faReply } from '@fortawesome/pro-solid-svg-icons/faReply'
import { faReplyAll } from '@fortawesome/pro-solid-svg-icons/faReplyAll'
import { faShare } from '@fortawesome/pro-solid-svg-icons/faShare'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'

library.add(
  faComments, faSearch, faDownload, faTrash, faWindowMaximize, faWindowMinimize, faCompressAlt, faExpandAlt,
  faTimes, faPaperclip, faBook, faMailBulk, faPlusCircle, faCheck, faFileUser, faFilter, faPlus, faInbox,
  faSquare, faMinusSquare, faCheckSquare, faSync, faChevronLeft, faChevronRight, faCaretRight, faCaretDown, faFolder,
  faHourglassStart, faPaperPlane, faFile, faExclamationCircle, faStar, faExclamation, faClock, faArrowLeft,
  faBoxAlt, faEnvelope, faFolderDownload, faReply, faReplyAll, faShare, faEllipsisV
)
